import styles from "./footer.module.scss";

export const Footer: React.FC = () => (
  <footer className={styles.footer}>
    <div className={styles.container}>
      <p>@2021 theycallmewolf, all rights yada yada yada</p>
    </div>
  </footer>
);
